import axios from "axios";
import { PreviewDaishi, TagID } from "../entities";
import { FrameLevelCellid, ImageChunk } from "../util";
import { ICloudStorageAccess } from "./cloudStorageAccess";

/**
 * ローカルファイルへのアクセスを提供します。
 * このクラスはローカル環境での開発時にしか使用できません。
 *
 * ローカルファイルへのアクセスは、`/localdb` 以下に配置されたファイルを読み込みます。
 * 例えば、parcel を使って開発サーバをホストしている場合は、
 * ./dist/localdb 以下にファイルを配置することで、ローカルファイルへのアクセスを行うことができます。
 */
export class LocalFileAccess implements ICloudStorageAccess {
  public async loadPreviewDaishi(tag: TagID): Promise<PreviewDaishi> {
    const fileRef = `/localdb/${tag.toString()}/header.txt`;
    const response = await axios.get(fileRef);
    return PreviewDaishi.parseText(response.data);
  }

  public async resolveUrl(
    tag: TagID,
    frame: FrameLevelCellid,
  ): Promise<ImageChunk> {
    const source = frame.fromR,
      dest = frame.toR,
      level = frame.level,
      cellid = frame.cellid,
      xx = cellid.x,
      yy = cellid.y,
      filename = `cell.${level}.${xx}.${yy}.jpg`,
      url = `/localdb/${tag}/${filename}`;

    return new ImageChunk(url, source, dest);
  }

  public async listTags(): Promise<TagID[]> {
    // NOTE: dist/localdb の中にあるデータを変更するたびに更新する必要がある
    return [new TagID("43.3")];
  }
}
